exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#error-session-expired .header-class-modal-doc-package h5 {\n  color: #fff;\n}\n", ""]);

// exports
